import { render, staticRenderFns } from "./BookmarkItem.vue?vue&type=template&id=a95ef3c6&scoped=true"
import script from "./BookmarkItem.vue?vue&type=script&lang=ts"
export * from "./BookmarkItem.vue?vue&type=script&lang=ts"
import style0 from "./BookmarkItem.vue?vue&type=style&index=0&id=a95ef3c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95ef3c6",
  null
  
)

export default component.exports